import { render } from "./TrackInfo.vue?vue&type=template&id=a3daf4b4"
import script from "./TrackInfo.vue?vue&type=script&lang=js"
export * from "./TrackInfo.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__